module.exports = __webpack_public_path__ + "static/media/process_01.8c4d6f9e.jpg";